import { Text } from '@medly-components/core';
import { WithStyle } from '@medly-components/utils';
import type { FC } from 'react';
import { memo } from 'react';

import NavItem from '../NavItem';
import { SubNavList } from '../SubNavList/SubNavList';
import { NavListStyled } from './NavList.styled';
import { NavListProps } from './types';

export const Component: FC<NavListProps> = memo(({ links, expandSidenav }) => {
    return (
        <NavListStyled>
            {links.map(link => (
                <NavItem
                    title={link.title}
                    path={link.path}
                    onClick={link.onClick}
                    key={link.title}
                    isActive={link.isActive || Boolean(link.subNavLinks?.some(link => link.isActive))}
                >
                    {link.subNavLinks ? (
                        <SubNavList expandSidenav={expandSidenav} {...link} />
                    ) : (
                        <>
                            {link.icon}
                            <Text textVariant="body1">{link.title}</Text>
                        </>
                    )}
                </NavItem>
            ))}
        </NavListStyled>
    );
});
Component.displayName = 'NavList';
export const NavList: FC<NavListProps> & WithStyle = Object.assign(Component, {
    Style: NavListStyled
});
